import React from "react";
import { Button, ButtonGroup, Card, Col, Row } from "react-bootstrap";
import Title from "../assets/title-border.png";
import Featured from "../assets/jobs-profile.png";
import MCQ from "../assets/mcq.jpg";
import Product from "../products/Product";
import Courses from "../data";
const RecentJobs = () => {
  return (
    <section className="recent-jobs">
      <Row className="px-5 pt-4 mx-0">
        <Col>
          <div class="pm-button">
            <a href="https://www.payumoney.com/paybypayumoney/#/10091C07D1EBE7FBF90E6B7D9AB01A60">
              <img src="https://www.payumoney.com/media/images/payby_payumoney/new_buttons/21.png" />
            </a>
          </div>
          <h2 className="text-center pb-0">
            <span>Courses Offered At VK Learning</span> <br />
            <img src={Title} alt="border" className="title-border" />
          </h2>
        </Col>
      </Row>
      <Row className="mx-0 jobs-recent pb-4">
        {Courses.map((course, index) => {
          return (
            <Col md={3} className="px-1 mb-2" key={index}>
              <Product details={course} />
            </Col>
          );
        })}
      </Row>
    </section>
  );
};

export default RecentJobs;
